import { HttpInterceptorPathResolver } from "./path-resolution-interceptor";
import { AssetPathResolutionService } from "./path-resolution-service";
import app from "../../sdAppModule";

app
  .config([
    "$provide",
    "$httpProvider",
    function ($provide: ng.auto.IProvideService, $httpProvider: ng.IHttpProvider) {
      $provide.factory("httpBeaconsInterceptor", [
        "$injector",
        function ($injector: ng.auto.IInjectorService) {
          return $injector.instantiate(HttpInterceptorPathResolver);
        }
      ]);
      $httpProvider.interceptors.push("httpBeaconsInterceptor");
    }
  ])
  .service("assetPathResolutionService", AssetPathResolutionService);
